import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Zap, Brain, Activity } from 'lucide-react';
const results = [{
  icon: Moon,
  text: 'Duermes profundo y continuo'
}, {
  icon: Zap,
  text: 'Energía estable todo el día'
}, {
  icon: Brain,
  text: 'Mente clara y sin niebla mental'
}, {
  icon: Activity,
  text: 'Abdomen que empieza a reducirse'
}];
export const ResultsSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-emerald text-white" data-id="element-121">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-122">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-123">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white" data-id="element-124">
            Lo que cambia cuando tu cortisol se regula
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-20" data-id="element-125">
          {results.map((result, index) => {
          const Icon = result.icon;
          return <motion.div key={index} className="flex flex-col items-center text-center gap-4" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-126">
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm" data-id="element-127">
                  <Icon className="w-8 h-8 text-brand-mint" data-id="element-128" />
                </div>
                <p className="text-lg font-medium text-brand-offwhite" data-id="element-129">
                  {result.text}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div className="max-w-4xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-md" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-130">
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 text-center md:divide-x divide-white/20" data-id="element-131">
            <div className="px-6 w-full md:w-auto" data-id="element-132">
              <span className="block text-4xl font-bold text-brand-mint mb-2" data-id="element-133">
                21
              </span>
              <span className="text-sm uppercase tracking-wider font-medium text-white/80" data-id="element-134">
                Días
              </span>
            </div>
            <div className="px-6 w-full md:w-auto pt-6 md:pt-0 border-t border-white/20 md:border-t-0" data-id="element-135">
              <span className="block text-4xl font-bold text-brand-mint mb-2" data-id="element-136">
                6
              </span>
              <span className="text-sm uppercase tracking-wider font-medium text-white/80" data-id="element-137">
                Capítulos
              </span>
            </div>
            <div className="px-6 w-full md:w-auto pt-6 md:pt-0 border-t border-white/20 md:border-t-0" data-id="element-138">
              <span className="block text-4xl font-bold text-brand-mint mb-2" data-id="element-139">
                1
              </span>
              <span className="text-sm uppercase tracking-wider font-medium text-white/80" data-id="element-140">
                Método probado
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
};